import { api } from '../lib';
import { setToast } from '../store/features/toastSlice';
import { store } from '../store/store/store';
import { getPaginationData } from '../utils/utils';
import { BaseService } from './base.service';
import LoaderService from './loader.service';

class UserService extends BaseService {
  constructor() {
    super('Users');
  }

  async getDeletionPermission() {
    try {
      LoaderService.showLoader();
      const res = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/Users/get-deletion-permission`
      );

      if (res.ok) {
        return { data: res.data, error: null };
      }

      return { data: null, error: res.data };
    } catch (error) {
      return { data: null, error: error };
    } finally {
      LoaderService.hideLoader();
    }
  }
}

const userSvc = new UserService();

export default userSvc;
